import { useEffect, useState } from 'react';
import { Server2 } from '../../redux/actions/auth/auth.actions';
import axios from 'axios';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../redux/actions/cart/cart.actions';
import { useNavigate } from 'react-router-dom';
import { LoaderLinearDots } from '../LoaderLinear';
import { FiX } from 'react-icons/fi';
import { slugify } from '../../utils';

const Catalogue = ({setImage, setProduct, userId}) => {

  const userData = useSelector((state) => state?.auth?.user?.user);
  const navigate = useNavigate();
  const [Products, setProducts] = useState([]);;
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleAddToCart = (product) => {
    if(product.variants?.size || product.variants?.colors) {
      navigate(`/product/${product?._id}`, { state: { item: product._id }})
      if(typeof setProduct === 'function' ) setProduct(product)
      if(typeof setImage === 'function' ) setImage(product.images[0])
    } else
    dispatch(
      addToCart({
        productId: product._id,
        productName: product.productName,
        price: product.price,
        taxCode: product.taxCode ? product.taxCode : 'txcd_10000000',
        shippingCost: product?.type === 'physical' ? product?.shipping?.shippingCost : 0,
        image: product.images[0],
        sellerId: product.userId,
      })
    );
  };

  const deleteProd = (id) => {
    let data = JSON.stringify({
      id: id,
      status: 'draft'
    });
    var config = {
      method: "post",
      url: Server2 + "/products/status-change ",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.message === "updated!") {
         setProducts(prevProducts => prevProducts.filter(p => p._id !== id));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const getProducts = () => {
    setIsLoading(true);
    let data = JSON.stringify({ id: userId, });
    var config = {
      method: "post",
      url: Server2 + "/products/get-by-user",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(config).then((response) => {
      console.log(response, 'i am response')
      setProducts(response.data);
      setIsLoading(false);
    })
    .catch((err) => {
      console.log(err, "error");
    });
  }

  useEffect(() => {
    getProducts()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      <div className="d-flex Cat-Main gap-3 py-2 px-1 mx-1" style={{}}>
      { isLoading ?
      // <p className="fs-6 text-capitalize rounded text-center pt-1" style={{ backgroundColor: "#ececec", width: "105px", height: "86px", marginBottom: "-1px" }}>No Products<br/>listed</p>
      <div className='mx-auto mb-3'>
        <LoaderLinearDots/>
      </div>
        : Products.length > 0 ? <> {Products?.map((product, index) => {
          return (
            <div className='position-relative p-3 rounded-3 bg-white'
              key={index}
              style={{ 
                // maxWidth: 255,
                // width: 255,
                boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 10px',
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate(`/product/${product?._id}`, { state: { item: product._id }})
                if(typeof setProduct === 'function' ) setProduct(product)
                if(typeof setImage === 'function' ) setImage(product.images[0])
                // window.location.reload(); // Forces a full page reload
              }}
            >
              {userData?._id === userId ?
                <FiX color='white' size={16} style={{
                  backgroundColor: "#6148a1",
                  borderRadius: 10,
                  position: "absolute",
                  top: "-4px",
                  right: "-7px",
                  cursor: "pointer",
                  padding: "2px"
                }} className='shadow' onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  deleteProd(product?._id);
                }} />
              : null}
              <div className='img-product-box-cat'>
                <img
                  key={index}
                  className="rounded-3 img-product"
                  src={product?.images[0]}
                  alt={"Images Product"}
                />
              </div>
              <div className='d-flex justify-content-between px-1 pb-2 pt-2'>
                <div style={{maxWidth: 150}}>
                  <p className='pt-1 fw-bolder clamp-1' style={{ height: 20, textOverflow: 'none', fontSize: 12 }} title={product?.productName}>{product?.productName}</p>
                  <p className='text-muted clamp-1' style={{ height: 18, textOverflow: 'none', fontSize: 12 }} title={product?.description}>{product?.description}</p>
                </div>
                <div style={{ minWidth: 70 }}>
                  <p className='text-end fw-bold' style={{ fontSize: 12 }}>Price:<br />${product?.price}</p>
                </div>
              </div>
              <Button className='w-100 d-flex gap-2 justify-content-center btn-ibouge' 
                disabled={product?.stock < 1 && product?.type !== 'digital'}
                onClick={(e)=> {
                  e.stopPropagation();
                  handleAddToCart(product)
                }}
              >
                Add to Cart
              </Button>
            </div>
          )
         })}
          <div className='position-relative p-3 rounded-3 bg-white'
            style={{ 
              // maxWidth: 255,
              // width: 255,
              boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 10px',
              cursor: 'pointer'
            }}
          >   
            {userData?._id === userId ? 
            <div className='d-flex justify-content-center align-items-center img-product-box-cat mt-5'>
              <Button className='d-flex gap-2 justify-content-center bg-white border-0 text-dark text-2xl'
                  onClick={(e)=> {
                    window.open(`http://sellerdashboard.ibouge.com/auth/${userData._id}/add`, '_blank')
                  }}
                >
                  +&nbsp;&nbsp;Add more products for sale
                </Button>
            </div>
            : null
            }
          </div>
        </> :
        <div className='w-100'>
          {/* <p className="fs-6 text-capitalize rounded text-center pt-1" style={{ backgroundColor: "#ececec", width: "105px", height: "86px", marginBottom: "-1px" }}>No Products<br/>to show</p> */}
          {userData?._id === userId ? 
          <div className='d-flex justify-content-center mb-3'>
            <Button className='d-flex gap-2 justify-content-center ib-btn'
                onClick={(e)=> {
                  window.open(`http://sellerdashboard.ibouge.com/auth/${userData._id}/add`, '_blank')
                }}
              >
                +&nbsp;&nbsp;Add Products for Sale
              </Button>
          </div>
          :
          <p className="fs-6 text-capitalize text-muted rounded text-center pb-4">No Products to show</p>
          }
        </div>
      }
      </div>
    </>
  )
}

export default Catalogue